import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'app-inclino-v2',
  templateUrl: './inclino-v2.component.html',
  styleUrls: ['./inclino-v2.component.css']
})
export class InclinoV2Component implements OnInit {

    @Input('paramFormInclinoV2') paramFormInclinoV2: FormGroup;
    @Input('readOnly') readOnly: boolean;
  constructor() { }

  ngOnInit() {
  }

}
